import script from "./AllApp.vue?vue&type=script&lang=ts&setup=true"
export * from "./AllApp.vue?vue&type=script&lang=ts&setup=true"

import "./AllApp.vue?vue&type=style&index=0&id=032e56fe&scoped=true&lang=less"
import "./AllApp.vue?vue&type=style&index=1&id=032e56fe&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-032e56fe"]])

export default __exports__